type Account = { name: string; email: string; password: string };
type Request = (path: string, method: string, data: unknown) => Promise<any>;

// Existing accounts must prove their password before the invitation can grant access.
export async function joinProject(
  request: Request,
  token: string,
  account: Account,
  existingAccount: boolean,
) {
  let name = account.name;
  if (existingAccount) {
    const signedIn = await request("/auth/sign-in/email", "POST", {
      email: account.email,
      password: account.password,
    });
    name = signedIn.user.name;
  }
  await request("/invitations/accept", "POST", { ...account, name, token });
  if (!existingAccount)
    await request("/auth/sign-in/email", "POST", {
      email: account.email,
      password: account.password,
    });
}
